export default __webpack_public_path__ + "static/media/Contact-sales-Main-page-final-825x340.36739e6b.png";